import { CodeParameters } from '../models/sales/code-parameters';

// Where a sales order line is NOW, in Jean's words (Sales Order What's Happened, D-22) - the
// Stage column of the What's Happened tab, the Sales Order Line Exceptions list and the line
// audit. Mirrors TMSWeb.Common.Constants.LineStages: the API sends a CODE plus parameters (D-9),
// because its responses are not translated server-side, and the words are here in $localize. The
// two lists must stay in step.
export enum LineStages {
  waitingForStock = 'WaitingForStock',
  waitingForRawMaterial = 'WaitingForRawMaterial',
  inProduction = 'InProduction',
  // Via Transfer
  expectedOnPallet = 'ExpectedOnPallet',
  loadedOnPallet = 'LoadedOnPallet',
  // Parameter: warehouse - the receiving warehouse's name ("Arrived in Switzerland" on Jean's sheet).
  arrivedIn = 'ArrivedIn',
  // Direct / Local Stock
  made = 'Made',
  onPickingList = 'OnPickingList',
  picked = 'Picked',
  // Both
  despatched = 'Despatched',
  cancelled = 'Cancelled',
}

// The stage as a person reads it.
export function lineStageText(stage: CodeParameters | undefined | null): string {
  const warehouse = stage?.parameters?.['warehouse'];
  switch (stage?.code) {
    case LineStages.waitingForStock:
      return $localize`Waiting for stock`;
    case LineStages.waitingForRawMaterial:
      return $localize`Waiting for raw material`;
    case LineStages.inProduction:
      return $localize`In production`;
    case LineStages.expectedOnPallet:
      return $localize`Expected on pallet`;
    case LineStages.loadedOnPallet:
      return $localize`Loaded on pallet`;
    case LineStages.arrivedIn:
      // The API leaves the warehouse out when the receipt names none.
      return warehouse ? $localize`Arrived in ${warehouse}:warehouse:` : $localize`Arrived`;
    case LineStages.made:
      return $localize`Made`;
    case LineStages.onPickingList:
      return $localize`On picking list`;
    case LineStages.picked:
      return $localize`Picked`;
    case LineStages.despatched:
      return $localize`Despatched`;
    case LineStages.cancelled:
      return $localize`Cancelled`;
    default:
      // Anything unrecognised shows as sent rather than vanishing.
      return stage?.code ?? '';
  }
}
